import { InjectionToken } from '@angular/core';

export const SOFTLINE_FEATURE_LAGERPLATZ_UMLAGERUNG = 'lagerplatzUmlagerung';
export const SOFTLINE_PERMISSION_LAGERPLATZ_UMLAGERUNG = 'SOFTAPPS.LAGER.LAGERPLATZ_UMLAGERUNG';

export interface LagerplatzUmlagerungConfig {
  artehEingabe: boolean
}

export const SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG = new InjectionToken<LagerplatzUmlagerungConfig>(
  'SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG'
);
